import React, {Component} from 'react';
import {Container} from "react-grid-system";
import _ from 'underscore';
import Group from "./Voting/Group";
import GroupFilter from "./Voting/GroupFilter";
import Record from "./Voting/Record";
import {HashRouter  as Router, Redirect, Route} from 'react-router-dom'
import Modal from 'react-responsive-modal';
import './Voting/Modal.css';
import jsonata from 'jsonata';
import axios from 'axios';

class Voting extends Component {

    state = {
        groups: [],
        active: null,
        modalOpen: false,
        modalRecord: null,
        email: localStorage.getItem('email')
    };

    constructor(props) {
        super(props);

        this.records = [];
        this.askForVote = this.askForVote.bind(this);
    }

    componentDidMount() {
        const groupColumn = this.props.voting.configurations.group.split("#");
        const sortColumn = this.props.voting.configurations.sort;
        const groups = {};

        this.props.voting.data.forEach(data => {
            this.records[data.id] = data;

            let column = data.fields[groupColumn[0]];
            if (groupColumn.length === 2) {
                if (Array.isArray(column) && column.length > 0) {
                    column = column[0].fields[groupColumn[1]];
                }
            }

            if (!column) {
                column = "Non déterminé";
            }

            if (!(column in groups)) {
                groups[column] = [];
            }

            groups[column].push(data);
        });

        const groupsSort = [];
        _.each(groups, (group, key) => {
            if (sortColumn !== 'disable') {
                group.sort((a, b) => {
                    if (a.fields[sortColumn] > b.fields[sortColumn]) {
                        return 1;
                    }
                    if (a.fields[sortColumn] < b.fields[sortColumn]) {
                        return -1;
                    }
                    return 0;
                });
            }

            groupsSort.push({key, entries: group});
        });

        groupsSort.sort((a, b) => {
            if (a.key > b.key) {
                return 1;
            }
            if (a.key < b.key) {
                return -1;
            }
            return 0;
        });

        let first = groupsSort[0];

        this.setState({
            groups: groupsSort,
            active: first ? first.key : null
        })
    }

    askForVote(record) {
        this.setState({
            modalOpen: true,
            modalRecord: record
        })
    }

    vote() {
        axios.post(window.EndPointVote, {
            email: this.votingEmail.value,
            record: this.state.modalRecord.id
        })
            .then((response) => {
                localStorage.setItem('email', this.votingEmail.value);
                if (response.data.state === 'success') {
                    this.props.updateVoting(response.data.voting);
                }
                this.setState({modalRecord: null, modalOpen: false, email: this.votingEmail.value});
            })
            .catch((error) => {
            });
    }

    render() {
        let modalTitle = "";
        if (this.state.modalRecord) {
            try {
                let exp = jsonata(this.props.voting.configurations.title);
                modalTitle = exp.evaluate(this.state.modalRecord);
                if (!modalTitle && this.props.voting.configurations.fallback) {
                    exp = jsonata(this.props.voting.configurations.fallback);
                    modalTitle = exp.evaluate(this.state.modalRecord);
                }
            } catch(e) {
            }
        }

        return (
            <Router>
                <Container fluid={false} style={{marginTop: '30px'}}>
                    <Modal open={this.state.modalOpen} onClose={() => this.setState({modalOpen: false, modalRecord: null})} center>
                        <div className="r-modal">
                            <h3>Voter pour <span>{modalTitle}</span></h3>

                            <label>Votre adresse e-mail</label>
                            <input type="email" defaultValue={this.state.email} ref={node => (this.votingEmail = node)}/>

                            <div style={{textAlign: 'center'}}>
                                <button className="Voting-Button" onClick={() => {this.vote();}}>Voter <i className="fas fa-heart"/></button>
                            </div>
                        </div>
                    </Modal>
                    <Route exact path="/" render={() => {
                        if (this.state.active !== null) {
                            return <Redirect to={/filters/ + this.state.active.replace("/", "-")}/>
                        } else {
                            return null;
                        }
                    }}/>
                    <div className="Voting-Group-Filters">
                        {this.state.groups.map((group) => {
                            if (this.state.groups.length === 1) {
                                return null;
                            }
                            return (
                                <Route path={"/filters/" + group.key.replace("/", "-")}
                                       key={"route-"+group.key}
                                       children={({match}) => (
                                           <GroupFilter key={group.key}
                                                        data={group}
                                                        active={match}
                                                        configuration={this.props.voting.configurations}
                                           />
                                       )}
                                />
                            );
                        })}
                    </div>

                    <Route path="/record/:id" render={(match) => {
                        if (match.match.params.id in this.records) {
                            return (<Record entry={this.records[match.match.params.id]}
                                            voting={this.props.voting}
                                            onAskForVote={() => {this.askForVote(this.records[match.match.params.id]);}}
                                            configuration={this.props.voting.configurations}
                                            displayBackButton={this.state.groups.length === 1}/>)
                        }
                        return <div>Not Found</div>;
                    }}/>

                    {this.state.groups.map((group) => {
                        return (
                            <Route key={"route-group-"+group.key} path={/filters/ + group.key.replace("/", "-")} render={() => {
                                if (this.state.active !== group.key) {
                                    this.setState({active: group.key});
                                }
                                return (
                                    <Group
                                        onAskForVote={this.askForVote}
                                        entries={group.entries}
                                        voting={this.props.voting}
                                        configuration={this.props.voting.configurations}
                                        format={this.props.voting.configurations.format}
                                        name={group.key}
                                        key={group.key}/>
                                );
                            }}/>
                        )
                    })}
                </Container>
            </Router>
        );
    }
}

export default Voting;


// WEBPACK FOOTER //
// ./src/Components/Voting.js